module.exports = __webpack_public_path__ + "img/model2_zh.f6d3856e.png";